import NewPassword from "./NewPassword";

export default NewPassword;
